<template>
  <MensagemErro v-if="erro" :titulo="titulo" :classe="nomeImposto" />
  <LoadingResultado borderTop v-else-if="ativarLoading" :titulo="titulo" :classe="nomeImposto" />
  <MultiplosSemResultado v-else-if="!exibeImposto" :titulo="titulo" :classe="nomeImposto" />
  <div v-else-if="imposto">
    <h2 class="nome-impressao">IMPOSTO DE EXPORTAÇÃO</h2>
    <QuadroAlerta
      v-if="!!imposto.dados.length"
      :classe="nomeImposto"
      :dadosForm="dadosForm"
      @exibeAlerta="alerta => (exibeAlerta = alerta)"
    />
    <QuadroPrincipal
      :key="getRenderKey"
      :borderTop="!imposto.dados.length || !exibeAlerta"
      :titulo="imposto.nome"
      :classe="imposto.classe"
    >
      <RegistrosExportacao
        :imposto="imposto"
        :classe="nomeImposto"
        :seleciona="seleciona"
        :edita="edita"
        :selecionouExportacao="selecionouExportacao"
        :registroSelecionado="impostoSelecionado"
      />
    </QuadroPrincipal>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import LoadingResultado from "@/components/LoadingResultado/LoadingResultado.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";
import MensagemErro from "@/components/MensagemErro/MensagemErro.vue";
import MultiplosSemResultado from "@/components/ImpostoSemResultado/MultiplosSemResultado.vue";
import QuadroAlerta from "@/components/QuadroAlerta/QuadroAlerta.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import Registro from "@/components/Registro/Registro.vue";
import Separador from "@/components/Fields/Separador/Separador.vue";
import RegistrosExportacao from "@/components/RegistrosExportacao/RegistrosExportacao.vue";

import stringFormatMixin from "@/mixins/stringFormatMixin";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [stringFormatMixin],
  name: "Exportacao",

  props: {
    id: String | Number,
    tributoAtivo: String,
    buscarImposto: Function,
    exibeImposto: Boolean,
    dadosForm: Array | Object
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    LoadingResultado,
    MensagemErro,
    MultiplosSemResultado,
    QuadroPrincipal,
    Registro,
    Separador,
    Ncm,
    Notificacao,
    GrupoNotificacao,
    QuadroAlerta,
    RegistrosExportacao
  },

  data() {
    return {
      exibeAlerta: false,
      titulo: "EXPORTAÇÃO",
      nomeImposto: "exportacao",
      imposto: null,
      impostoSelecionado: {},
      selecionouExportacao: false,
      erro: false,
      ativarLoading: false
    };
  },

  created() {
    this.setSelecao({ selecao: { selecionouExportacao: this.selecionouExportacao }, id: this.id });
  },

  updated() {
    if (this.selecionouExportacao) {
      this.setLog(this.impressaoLog);
    }
  },

  watch: {
    async tributoAtivo(newValue) {
      this.erro = false;
      this.ativarLoading = true;
      if (newValue == this.nomeImposto && !this.imposto && this.exibeImposto) {
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            [this.imposto] = await this.buscarImposto({
              imposto: this.nomeImposto,
              idCenario: this.id
            });
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoading = false;
            }
          }
        }
        if (this.imposto.dados.length == 1) {
          this.seleciona(this.imposto.dados[0]);
        }
      }
      this.ativarLoading = false;
    },

    ativarLoading() {
      this.$emit("loading", this.ativarLoading);
    },

    selecionouExportacao() {
      this.setSelecao({
        selecao: { selecionouExportacao: this.selecionouExportacao },
        id: this.id
      });
    },

    impressaoLog() {
      let log = {
        logExportacao: {
          imposto: this.impostoSelecionado
        }
      };
      return log;
    }
  },

  computed: {
    ...mapGetters("reRender", ["getRenderKey"])
  },

  methods: {
    ...mapActions("tributosSelecionados", ["setSelecao"]),
    ...mapActions("logResultados", ["setLog"]),

    seleciona(imposto) {
      this.impostoSelecionado = imposto;
      this.selecionouExportacao = true;
    },

    edita() {
      this.impostoSelecionado = {};
      this.selecionouExportacao = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
